import { Component, OnInit, OnDestroy } from '@angular/core';
import { SieniService } from 'src/app/shared/services/sieni.service';
import { MOrganization } from 'src/app/shared/models/organization.model';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { MModuleEvaluation } from 'src/app/shared/models/module-evaluation.model';
import { MProcess } from 'src/app/shared/models/process.model';
import { MEvaluation } from 'src/app/shared/models/evaluation.model';
import { MChapterData } from 'src/app/shared/models/chapter-data.model';
import { ChapterData, Breadcrumb } from 'src/app/shared/interfaces/Organization';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Alert } from 'src/app/shared/models/alert.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { element } from 'protractor';
import { EvaluationDataIdService } from 'src/app/shared/services/evaluation-data-id.service';
import { MReportType } from 'src/app/shared/models/report-type.model';
@Component({
  selector: 'app-evaluation-data',
  templateUrl: './evaluation-data.component.html',
  styleUrls: ['./evaluation-data.component.scss']
})
export class EvaluationDataComponent implements OnInit, OnDestroy {

  constructor(private _globalService: SieniService, 
    private translate: TranslateService, 
    private actvRoute: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private idService: EvaluationDataIdService) { 
      // this.router.events.subscribe((event: any) => {
      //   // console.log(event)
      //   if (event instanceof NavigationEnd) {
      //     console.log(event)
      //     if (!this.loading) {
      //       this.loading = true;
      //       this.moduleData = null;
      //       this.chapters = null;
      //       this.start()
      //     }
      //   }
      // })
      let verId = null;
      this.actvRoute.params.subscribe(params => {
        // console.log(params)
        // if (!this.versionId){
          
        this.checkVersion(params);
          
        // } else if(parseInt(params.version_id) === this.versionId){
         
        // }
      })
    }
  
  public org: MOrganization = null;
  public evaluation: MEvaluation = null;
  public evaluationInfo: MModuleEvaluation = null;
  public processes: MProcess[] = null;
  public selectedProcess: number = 0;
  public chapters: MChapterData[] = null;
  public filteredChapters: MChapterData[] = null;
  public moduleData: MChapterData = null;
  public id: number = null;
  public moduleId: number = null;
  public versionId: number = null;
  public chapterId: number = null;
  public indexId: number = null;
  public summaryType: string = null;
  public itemType: string = null;
  public itemUrl: string = null;
  public crumbs: Breadcrumb[] = [];
  public loading: boolean = false;
  public reloading: boolean = false;
  public canceling: boolean = false;
  public reportTypes: MReportType[] = [];
  public reportUrl: string = '';
  public gettingReport: boolean = false;
  public hash: string = '';
  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnInit() {
    this.translate.setDefaultLang('es');
    this.translate.use(this._globalService.user.language.code)
    // this.start();
  }

  ngOnDestroy(){
    // this.idService.setEvaluation(null);   
  }

  public checkVersion(params: any){

    this.getProcesses()

    this.chapters = null;
    this.moduleData = null;
    this.selectedProcess = 0;

    this._globalService.getCurrentOrganization().then(res=>{
      this.org = res
      
      // console.log(this.idService.getVersionId(), parseInt(params.version_id))

      if (this.idService.getEvaluation()
      && this.idService.getVersionId()) {
        if (this.idService.getVersionId() === parseInt(params.version_id)) {
          this.idService.setVersionId(parseInt(params.version_id))
          // console.log("Misma version")
          this.loadIds()

          this.evaluation = this.idService.getEvaluation()
          if (this.idService.getEvaluationInfo()){

            this.evaluationInfo = this.idService.getEvaluationInfo()

            if (this.idService.getProcessId() != 0) {
              this.selectedProcess = this.idService.getProcessId();
              this.getEvaluationSummaryForProcess()
            } else {
              this.selectedProcess = 0;
              this.getEvaluationSummary()
            }
          } else {
            this.selectedProcess = this.idService.getProcessId()
            this.getEvaluationStructure()
          }
        } else {
          // console.log("Otra version")
          this.idService.reset()
          this.idService.setVersionId(parseInt(params.version_id))
          // this.start()
        }
      } else {
        this.idService.reset()
        this.idService.setVersionId(parseInt(params.version_id))
        // this.start()
      }
      this.start()

    })
    
  }

  public start(){
    this.loadIds()
    this.startEvaluation()
  }

  public loadIds(){
    this.moduleId = this.actvRoute.snapshot.paramMap.get("module_id") ? 
      parseFloat(this.actvRoute.snapshot.paramMap.get("module_id")) : null;
    this.versionId = this.actvRoute.snapshot.paramMap.get("version_id") ? 
      parseFloat(this.actvRoute.snapshot.paramMap.get("version_id")) : null;
    this.chapterId = this.actvRoute.snapshot.paramMap.get("chapter_id") ? 
      parseFloat(this.actvRoute.snapshot.paramMap.get("chapter_id")) : null;
    this.indexId = this.actvRoute.snapshot.paramMap.get("index_id") ? 
      parseFloat(this.actvRoute.snapshot.paramMap.get("index_id")) : null;
      
    if (this.indexId) {
      this.hash = 'sieni/evaluations/*/version/*/chapter/*/index/*'
      this.itemUrl = "/sieni/evaluations/" + this.moduleId + "/version/" + this.versionId + "/chapter/" 
      + this.chapterId + "/index/" + this.indexId + "/item/";
      this.itemType = "evaluations.chapter.item";
      this.summaryType = "evaluations.chapter.index.singular";
    } 
    else if (this.chapterId) {
      this.hash = 'sieni/evaluations/*/version/*/chapter/*'
      this.itemUrl = "/sieni/evaluations/" + this.moduleId + "/version/" + this.versionId + "/chapter/"
      + this.chapterId + "/index/"
      this.itemType = "evaluations.chapter.index.singular";
      this.summaryType = "evaluations.chapter.title";
    } else {
      this.hash = 'sieni/evaluations/*/version/*'
      this.itemUrl = "/sieni/evaluations/" + this.moduleId + "/version/" + this.versionId + "/chapter/";
      this.itemType = "evaluations.chapter.title";
      this.summaryType = "module.title";
    }
  }

  public startEvaluation(){
    this._globalService.startEvaluation(this.versionId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(({data}:any)=>{
      // console.log(data);
      this.evaluation = new MEvaluation(data);
      // console.log(this.evaluation)
      this.idService.setEvaluation(this.evaluation) 
      // console.log(this.idService.getEvaluation())
      // console.log(this.evaluation);
      this._globalService.getReportTypes().pipe(takeUntil(this.ngUnsubscribe)).subscribe(res=>{
        // console.log(res)
        this.reportTypes = res;
        this.getPreviousEvaluations();
      })
    })
  }

  public getPreviousEvaluations(){
    // console.log(this.evaluation)
    if (this.evaluation.type === 'N') {
      this.getEvaluationStructure()
    } else {
      this._globalService.getEvaluationByVersionId(this.versionId).subscribe(({data}:any)=>{
        // console.log(data)
        // console.log(new MModuleEvaluation(data[0]))
        for (let i = 0; i < data.length; i++) {
          // console.log(data.subversion_modulo.version_modulo)
          if (data[i].subversion_modulo.version_modulo.existe_evaluacion) {
            // console.log(data[i])
            this.evaluationInfo = new MModuleEvaluation(data[i])
            this.idService.setEvaluationInfo(new MModuleEvaluation(data[i]))
            console.log(this.evaluationInfo)
            this.getEvaluationSummary()
            break;
          }          
        }
        if (!this.evaluationInfo) {
          this.getEvaluationStructure()
        }
      })
    }
  }

  public getProcesses(){

    this._globalService.getCurrentProcesses().then(res=>{
      this.processes = res
    })
  }

  public getEvaluationSummary(reloaded = false){
    this._globalService.getEvaluationSummary(this.evaluationInfo.id,
      this.chapterId,
      this.indexId
      ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(({data}:any)=>{
      if (data) {
        this.chapters = [];
        for (let i = 0; i < data.length; i++) {
          this.chapters.push(new MChapterData(data[i]))          
        }
        this.filteredChapters = this.chapters
        // console.log(this.chapters);
        
        this.generateModuleData(this.chapters)
        // console.log(this.moduleData)
      }
      let string: string = this.chapters[0].chapter.number 
      this.generateCrumb(string)
      this.loading = false;
      if (reloaded) {
        this.reloading = false;
        Alert.buildSuccessAlert(this.translate.instant('evaluations.process.reload'))
      }
    }, err => {
      if (reloaded) {
        this.reloading = false;
          Alert.buildErrorAlert(this.translate.instant('evaluations.process.reloadError'))
      }
    })

  }

  private getEvaluationSummaryForProcess(){
    this._globalService.getEvaluationSummary(this.evaluationInfo.id,
    this.chapterId,
    this.indexId
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(({data}:any)=>{
    if (data) {
      const chapters = []
      for (let i = 0; i < data.length; i++) {
        chapters.push(new MChapterData(data[i]))          
      }

      this._globalService.getEvaluationSummaryByProcess(this.selectedProcess,
      this.evaluationInfo.id,
      this.chapterId,
      this.indexId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(({data}:any) => {

        this.filteredChapters = [];
        data.forEach(chap => {
          this.filteredChapters.push(new MChapterData(chap))
        });

        this.chapters = chapters

        this.generateModuleData(this.filteredChapters)

        let string: string = this.chapters[0].chapter.number 
        this.generateCrumb(string)
        this.loading = false;
      })

      }

    }, err => {})
  }

  private getEvaluationStructure(reloaded = false){
    this._globalService.getEvaluationStructure(this.moduleId, this.versionId, this.chapterId, this.indexId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(({data}:any)=>{
        // console.log(data)
        this.chapters = []
        // if (this.chapterId) {
        data.forEach(element => {
          this.chapters.push(this.pushChapter(element))
        });
        // } else {
        //   data.capitulos.forEach(cap => {
        //     this.chapters.push(this.pushChapter(cap))
        //   });
        // }

        this.filteredChapters = []

        if (this.selectedProcess == 0) {
          this.filteredChapters = this.chapters
        } else {
          for (let i = 0; i < this.chapters.length; i++) {
            for (let j = 0; j < this.chapters[i].processes.length; j++) {
              if (this.chapters[i].processes[j].id === this.selectedProcess) {
                this.filteredChapters.push(this.chapters[i])
              }
            }
          }
        }


        this.moduleData = this.pushChapter({
          numero: null,
          id: null,
          titulo: null
        })

        let string: string = this.chapters[0].chapter.number 
        this.generateCrumb(string)
        this.loading = false;

        if (reloaded) {
          this.reloading = false;
          Alert.buildErrorAlert(this.translate.instant('evaluations.process.reloadError'))
        } else {
          this.selectedProcess = this.idService.getProcessId();
          this.setSelectedChapters(this.selectedProcess);
        }
        // console.log(this.chapters)
      }, err=>{
        if (reloaded) {
          this.reloading = false;
          Alert.buildErrorAlert(this.translate.instant('evaluations.process.reloadError'))
        }
      })
  }

  private pushChapter(element):MChapterData{
    return new MChapterData({
      req_activos: "0",
      apartado: {
        ayuda:element.ayuda,
        descripcion: "",
        id: element.id,
        numero: element.numero,
        titulo: element.titulo
      },
      req_conformes: "0",
      req_evaluados: "0",
      req_no_conformes: "0",
      req_no_evaluados: "0",
      procesos: element.procesos
    })
  }

  public getMaxScore(requirements: number): number{
    const maxScore = requirements / this.moduleData.activeRequirements * 100;
    return Math.round(maxScore);
  }

  private generateCrumb(string: string){

    this.crumbs = []

    this.crumbs.push({
      address: '/sieni',
      name: this.translate.instant("breadCrumbs.organization") + ": " + this.org.name.toUpperCase()
    })

    this.crumbs.push({
      address: "/sieni/evaluations/" + this.moduleId + "/version/" + this.versionId,
      name: this.evaluation.module.name + ":" + this.evaluation.version
    })

    let cont: number = 0
    let numbers: string[] = []
    numbers.push(string)

    // console.log(string)

    string = string.toString()

    if (!string){
      string = "";
    }

    while (string.lastIndexOf(".") > 0) {
      cont++
      string = string.substr(0, string.lastIndexOf("."))
      numbers.unshift(string)
    }

    for (let i = 0; i < cont; i++) {
      switch (i) {
        case 0:
          this.crumbs.push({
            address: "/sieni/evaluations/" + this.moduleId
            + '/version/' + this.versionId
            + '/chapter/' + this.chapterId,
            name: this.translate.instant("evaluations.chapter.title") + " " + numbers[i]
          })
          break;

        case 1:
          this.crumbs.push({
            address: "/sieni/evaluations/" + this.moduleId
            + '/version/' + this.versionId
            + '/chapter/' + this.chapterId
            + '/index/' + this.indexId,
            name: this.translate.instant("evaluations.chapter.index.singular") + " " + numbers[i]
          })
          break;
      }
    }
  }

  public setSelectedChapters(id: number = null){
    // console.log(this.chapters)
    this.idService.setProcessId(this.selectedProcess)
    // console.log(this.idService.processId)
    if (id > 0) {
      // console.log(id)
      if (this.evaluationInfo) {
        this.filteredChapters = null;
        // this.moduleData = null;
        this.ngUnsubscribe.next();
        this._globalService.getEvaluationSummaryByProcess(this.selectedProcess,
          this.evaluationInfo.id,
          this.chapterId,
          this.indexId)
          .pipe(takeUntil(this.ngUnsubscribe)).subscribe(({data}:any)=>{
          // console.log(data)
          if (data) {
            this.filteredChapters = [];
            for (let i = 0; i < data.length; i++) {
              this.filteredChapters.push(new MChapterData(data[i]))          
            }
            
            this.generateModuleData(this.filteredChapters)
            // console.log(this.moduleData)
          }
        })
      } else {
        this.filteredChapters = []
        for (let i = 0; i < this.chapters.length; i++) {
          for (let j = 0; j < this.chapters[i].processes.length; j++) {
            // console.log(this.chapters[i].processes[j].id + " = " + id)
            if (this.chapters[i].processes[j].id == id) {
              this.filteredChapters.push(this.chapters[i])
            }
          }
        }
      }
    } else {
      // console.log(this.selectedProcess)
      this.filteredChapters = this.chapters
      if(this.evaluationInfo) this.generateModuleData(this.chapters)
    }
    // console.log(this.filteredChapters)
  }

  public openModal(content){
    this.modalService.open(content, {centered: true}).result.then(res=>{
      // console.log("Hola")
      this.canceling = true;
      this._globalService.deleteEvaluation(this.evaluationInfo.id).subscribe(res=>{
        Alert.buildSuccessAlert(this.translate.instant('evaluations.cancel.success'))
        this.router.navigate(['/sieni'])
      }, err=>{
        Alert.buildErrorAlert(this.translate.instant('evaluations.cancel.error'))
        this.canceling = false;
      })
    }, err=>{})
  }

  public setTakers(content){
    this.modalService.open(content, {centered: true}).result.then(res=>{
      Alert.buildSuccessAlert(this.translate.instant('evaluations.takers.update'))
    }, err=>{})
  }

  public reloadProcesses(){
    this.reloading = true;
    // debugger
    this._globalService.getProcesses().pipe(takeUntil(this.ngUnsubscribe)).subscribe(({data}:any)=>{
      // console.log(data)
      this.selectedProcess = 0
      this.processes = [];
      // data.data.foreach(p => {
      //   this.processes.push(new MProcess(p))
      // })
      for (let i = 0; i < data.length; i++) {
        this.processes.push(new MProcess(data[i]))
      }

      this._globalService.processes = this.processes

      if (this.evaluationInfo) {
        this.getEvaluationSummary(true)
      } else {
        this.getEvaluationStructure(true)
      }
      // this.reloading = false;
    }, err => {
      // console.log(err)
      this.reloading = false;
      Alert.buildErrorAlert(this.translate.instant('evaluations.process.reloadError'))
    })
  } 

  public generateModuleData(chapters: MChapterData[]){
    let activeRequirements: number = 0;
    let conformedRequirements: number = 0;
    let evaluatedRequirements: number = 0;
    let nonConformedRequirements: number = 0;
    let nonEvaluatedRequirements: number = 0;
    for (let i = 0; i < chapters.length; i++) {
      activeRequirements = activeRequirements + chapters[i].activeRequirements;
      conformedRequirements = conformedRequirements + chapters[i].conformedRequirements;
      evaluatedRequirements = evaluatedRequirements + chapters[i].evaluatedRequirements;
      nonConformedRequirements = nonConformedRequirements + chapters[i].nonConformedRequirements;
      nonEvaluatedRequirements = nonEvaluatedRequirements + chapters[i].nonEvaluatedRequirements;
    }
    const mData: ChapterData = {
      capitulo: null,
      req_activos: activeRequirements.toString(),
      req_conformes: conformedRequirements.toString(),
      req_evaluados: evaluatedRequirements.toString(),
      req_no_conformes: nonConformedRequirements.toString(),
      req_no_evaluados: nonEvaluatedRequirements.toString()
    }
    this.moduleData = new MChapterData(mData)
  }

  // public getReport(){
  //   if (this.reportUrl !== '') {
  //     this.gettingReport = true;
  //     let url = this.reportUrl
  //     .replace('{toolbox_id}', `1`)
  //     .replace('{id}', `${this.evaluationInfo.id}`)
  //     this._globalService.getReport(url).subscribe((res:any)=>{
  //       var file = new Blob([res], {type: 'application/pdf'});
  //       var fileURL = URL.createObjectURL(file);
  //       window.open(fileURL);
  //       this.gettingReport = false;
  //     }, (err)=>{
  //       if (err.status === 404) Alert.buildErrorAlert(this.translate.instant('history.alert.404')) 
  //       else Alert.buildErrorAlert(this.translate.instant('history.alert.error'))
  //       this.gettingReport = false;
  //     })
  //   }
  // }
}
